import { Grid, Typography as MuiTypography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",

  ".MuiTypography-root": {},

  svg: {
    fontSize: ".6em",
  },
});

export const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== "masked",
})<{ masked: boolean }>(
  {
    margin: 0,
    fontSize: "1.2em",
  },
  ({ masked }) => ({
    ...(masked && { fontSize: "1.7em", paddingTop: "10px" }),
  })
);
